import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "About — LegalDecoder" },
      {
        name: "description",
        content:
          "We translate dense legal documents into plain English so you can sign with confidence.",
      },
      { property: "og:title", content: "About — LegalDecoder" },
      {
        property: "og:description",
        content:
          "We translate dense legal documents into plain English so you can sign with confidence.",
      },
      { property: "og:url", content: "https://legaldecoder.io/about" },
    ],
    links: [{ rel: "canonical", href: "https://legaldecoder.io/about" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          url: "https://legaldecoder.io/about",
          name: "About LegalDecoder",
          description:
            "LegalDecoder translates dense legal documents into plain English for renters, freelancers, and small business owners.",
          publisher: {
            "@type": "Organization",
            name: "legaldecoder",
            url: "https://legaldecoder.io/",
          },
        }),
      },
    ],
  }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
          We've got your back.
        </h1>
        <p className="mt-6 text-lg text-muted-foreground">
          LegalDecoder was built for renters, freelancers, and small business owners who can't
          afford a lawyer for every document — but still need to understand what they're signing.
        </p>

        <section className="mt-12 space-y-6">
          <h2 className="text-2xl font-semibold text-foreground">Our mission</h2>
          <p className="text-muted-foreground">
            Reduce signing anxiety. Surface the traps before they cost you. Use AI to give every
            person the kind of contract review previously reserved for those with a lawyer on
            retainer.
          </p>
        </section>

        <section className="mt-12 space-y-6">
          <h2 className="text-2xl font-semibold text-foreground">Privacy first</h2>
          <p className="text-muted-foreground">
            Your documents are encrypted in transit, analyzed in-memory, and purged immediately
            after your session. We never use your files to train AI models. Bank-grade security,
            zero data retention.
          </p>
        </section>

        <p className="mt-16 text-xs uppercase tracking-wider text-muted-foreground">
          Not legal advice. For informational purposes only.
        </p>
      </main>
      <Footer />
    </div>
  );
}
